import { Children, isValidElement, createElement } from 'react';
import SearchBarItem from './SearchBarItem/bundle.esm.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const addOnClickPropertyToChild = (children, onClickItem) => {
  return Children.map(children, (child) => {
    var _a, _b;
    if (!child) {
      return child;
    }
    if (!isValidElement(child)) {
      return child;
    }
    if (child.type === SearchBarItem) {
      return createElement(
        child.type,
        __spreadProps(__spreadValues({}, child.props), {
          id: child.props.query,
          onClick: (event) => {
            var _a2, _b2;
            event.preventDefault();
            if (child.props.query) {
              onClickItem(child.props.query);
            }
            (_b2 = (_a2 = child.props) == null ? void 0 : _a2.onClick) == null ? void 0 : _b2.call(_a2);
          }
        }),
        addOnClickPropertyToChild((_a = child.props) == null ? void 0 : _a.children, onClickItem)
      );
    }
    if (!((_b = child.props) == null ? void 0 : _b.children)) {
      return child;
    }
    return createElement(
      child.type,
      __spreadProps(__spreadValues({}, child.props), {
        onMouseDown: (event) => {
          var _a2, _b2;
          event.preventDefault();
          (_b2 = (_a2 = child.props) == null ? void 0 : _a2.onClick) == null ? void 0 : _b2.call(_a2);
        },
        onClick: void 0
      }),
      addOnClickPropertyToChild(child.props.children, onClickItem)
    );
  });
};

export { addOnClickPropertyToChild };
//# sourceMappingURL=bundle.esm4.js.map
